import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FreeHtml from '../FreeHtml';
import { parentContainer, scribeDocumentBase } from '../ScribePropTypes';
import GraphicPageComponent from 'apps/analytics/components/GraphicPageComponent';
import { sendAdvertAnalytics } from 'apps/analytics';
import GraphicImpression from 'apps/gtm/containers/GraphicImpression';
import impressionTypes from 'apps/gtm/utils/gtmImpressionTypes';
import sendPromotionClickEvent from 'apps/gtm/utils/sendPromotionClickEvent';
import scribeDocumentTypes from '../utils/scribeDocumentTypes';

export default class FreeHtmlBanner extends PureComponent {
  static propTypes = {
    ...scribeDocumentBase,
    ...parentContainer,
    betaFeatureName: PropTypes.string,
    gtmPageType: PropTypes.string.isRequired,
    checkVisibilityOnMobile: PropTypes.bool.isRequired,
    forceVisibilityOnMobile: PropTypes.bool.isRequired,
    html: PropTypes.string.isRequired,
    showOnMobile: PropTypes.bool,
    updatable: PropTypes.bool,
  };

  static defaultProps = {
    updatable: false,
  };

  sendAnalytics = () => {
    const {
      docNo,
      docVersionNo,
      docTitle,
      parentContainer: {
        docNo: parentNo,
        docVersionNo: parentVersionNo,
        docTitle: parentTitle,
      },
      gtmPageType,
    } = this.props;
    sendAdvertAnalytics(this.props, this.props.parentContainer);
    sendPromotionClickEvent({
      id: docNo,
      id2: `${docNo}-${docVersionNo}-${parentNo}-${parentVersionNo}`,
      text: docTitle,
      creative: parentTitle,
      position: scribeDocumentTypes.FREEHTML,
      gtmPageType,
    });
  };

  shouldShowOnMobile = () => this.props.forceVisibilityOnMobile || (
    this.props.checkVisibilityOnMobile && this.props.showOnMobile
  );

  render() {
    const {
      html,
      updatable,
      docNo,
      docVersionNo,
      docTitle,
      parentContainer: {
        docNo: parentNo,
        docVersionNo: parentVersionNo,
        docTitle: parentTitle,
      },
    } = this.props;
    const id2 = `${docNo}-${docVersionNo}-${parentNo}-${parentVersionNo}`;

    return (
      <div className={classNames({ freeHtml: true, 'show-for-xlarge': !this.shouldShowOnMobile() })}>
        <GraphicPageComponent
          docNo={docNo}
          docVersionNo={docVersionNo}
          parentNo={parentNo}
          parentVersionNo={parentVersionNo}
          description="FREEHTML"
        />
        <GraphicImpression
          id={docNo}
          id2={id2}
          name={docTitle}
          creative={parentTitle}
          position={impressionTypes.FREEHTML}
        />
        <FreeHtml html={html} onHtmlLinkClick={this.sendAnalytics} updatable={updatable} />
      </div>
    );
  }
}
